import { hexToHSL } from '@/lib/hexToHSL';

export default defineNuxtPlugin(async (_nuxtApp) => {
  const creditPacks = await getCreditPacks() || [];
  const parkingPacks = await getParkingPacks() || [];

  document.documentElement.style.setProperty('--nav-link', hexToHSL("#FFBD59"));
  globalConfig().setPacks([...creditPacks, ...parkingPacks]);
});
